export const THEME_COLOR_OPTIONS = [
  { value: 'headerFooter', cssVar: '--color-header-footer' },
  { value: 'menuDesplegable', cssVar: '--color-menu-desplegable' },
  { value: 'cta1', cssVar: '--color-cta-1' },
  { value: 'cta2', cssVar: '--color-cta-2' },
  { value: 'fondo', cssVar: '--color-fondo' },
];

const THEME_COLOR_MAP = Object.fromEntries(
  THEME_COLOR_OPTIONS.map((option) => [option.value, option])
);

const HEX_COLOR_RE = /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const RGB_COLOR_RE = /^rgba?\(([^)]+)\)$/i;

export const normalizeColorValue = (value) => (
  typeof value === 'string' ? value.trim() : ''
);

export const getThemeColorCssValue = (themeColorKey) => {
  const option = THEME_COLOR_MAP[themeColorKey];
  return option ? `var(${option.cssVar})` : '';
};

export const getThemeColorRawValue = (themeColorKey, themeConfig) => {
  const normalizedKey = normalizeColorValue(themeColorKey);
  if (!normalizedKey) return '';

  return normalizeColorValue(themeConfig?.colors?.[normalizedKey]);
};

const expandHex = (value) => {
  const hex = value.replace('#', '');

  if (hex.length === 3) {
    return hex.split('').map((char) => `${char}${char}`).join('');
  }

  if (hex.length === 8) {
    return hex.slice(0, 6);
  }

  return hex;
};

const parseHexColor = (value) => {
  if (!HEX_COLOR_RE.test(value)) return null;

  const expanded = expandHex(value);

  return {
    red: parseInt(expanded.slice(0, 2), 16),
    green: parseInt(expanded.slice(2, 4), 16),
    blue: parseInt(expanded.slice(4, 6), 16),
  };
};

const parseRgbColor = (value) => {
  const match = value.match(RGB_COLOR_RE);
  if (!match) return null;

  const [red, green, blue] = match[1]
    .split(',')
    .slice(0, 3)
    .map((channel) => Number.parseFloat(channel.trim()));

  if ([red, green, blue].some((channel) => Number.isNaN(channel))) {
    return null;
  }

  return { red, green, blue };
};

export const isDarkColor = (value) => {
  const normalizedValue = normalizeColorValue(value);
  if (!normalizedValue) return false;

  const rgb = parseHexColor(normalizedValue) || parseRgbColor(normalizedValue);
  if (!rgb) return false;

  const brightness = ((rgb.red * 299) + (rgb.green * 587) + (rgb.blue * 114)) / 1000;
  return brightness < 150;
};